// Studio-level copy — voice: confident with edge. Edit freely; this file is the single source.
export const STUDIO = {
    tagline: 'Independent animation studio.',
    statement: 'We make films we have no business making.',
    introHeading: "Hi. We're Maximum.",
    introBody:
        'An independent animation studio telling stories too strange, too sad, or ' +
        'too ambitious for anyone else to fund. We are small on purpose, slow on ' +
        'purpose, and currently pouring everything into our first film.',
    makingOfHeading: 'Watch us build it.',
    makingOfBody:
        'Building a professional animated short in Unreal Engine with no budget and no prior experience; documenting every step. So you can do it too.',
    workHeading: 'The work',
    newsletterHeading: 'Get the film first.',
    newsletterSub:
        'The email list gets ETERNITY before anyone else. No noise, no spam — releases and the occasional milestone.',
    contactHeading: 'Talk to us (Promise we\'re nice)',
};
